'use client'
import axios, { AxiosError } from 'axios'
import { ENV } from '@school/common/common-utils/utils/envUtils'
import Cookies from 'js-cookie'
import { toast } from 'react-toastify'
import { ErrorResponse } from '@school/schemas/typeInterface'

const API_BASE_URL = ENV.SCHOOL_MANAGE_API_BASE_URL || 'http://localhost:8020/'
const API_BASE_URL_ENDPOINT = API_BASE_URL + 'api-school/v1/allen-school/'
// Axios instance
const http = axios.create({
  baseURL: API_BASE_URL_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
http.interceptors.request.use(
  (config) => {
    // You can add auth token here if needed
    const token = Cookies.get('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error instanceof Error ? error : new Error(String(error)))
  },
)

const handleAxiosError = (status: number | undefined) => {

  if (status === 401) {
    Cookies.remove('token')
    sessionStorage.clear()

    setTimeout(()=>{
      window.location.href = '/login'
    },5000)
   
  }
}

// Response interceptor
http.interceptors.response.use(
  
  (response) => {
    return response
  },
  (error: unknown) => {
    // Handle errors here
    if (error instanceof AxiosError && error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const errorData = error.response?.data as ErrorResponse
       const status = error.response.status 
       const backendError = (error.response.data as any)?.error

      const message = Array.isArray(errorData?.message)
        ? errorData.message[0]
        : errorData?.message || error.message || 'Something went wrong'

        if (error?.status === 401) {
          toast.error(backendError || 'Unauthorized access')
        }
      else if (error?.status !== 501) toast.error(message)
      handleAxiosError(status)
    } else if (error instanceof AxiosError && error.request) {
      toast.error('No response received from the server')
    } else {
      toast.error('Request setup error')
    }
    return Promise.reject(error instanceof Error ? error : new Error(String(error)))
  },
)
export default http
